import { AuditLogAction } from '@navio/nsdk';
import type { BadgeVariant } from 'noddi-ui-web';

/**
 * Single source of truth for audit log action display.
 * Add new entries here when backend adds new AuditLogAction values.
 */
const AUDIT_LOG_ACTION_OPTIONS: Partial<Record<AuditLogAction, { label: string; variant: BadgeVariant }>> = {
  [AuditLogAction.CREATE]: { label: 'Create', variant: 'success' },
  [AuditLogAction.UPDATE]: { label: 'Update', variant: 'default' },
  [AuditLogAction.DELETE]: { label: 'Delete', variant: 'destructive' },
  [AuditLogAction.ACCESS]: { label: 'Access', variant: 'outline' }
};

const getAuditLogActionLabel = (action: AuditLogAction): string =>
  AUDIT_LOG_ACTION_OPTIONS[action]?.label ?? String(action);

const getAuditLogActionBadgeVariant = (action: AuditLogAction): BadgeVariant =>
  AUDIT_LOG_ACTION_OPTIONS[action]?.variant ?? 'default';

export const getAuditLogActionOptions = (action: AuditLogAction): { label: string; variant: BadgeVariant } => ({
  label: getAuditLogActionLabel(action),
  variant: getAuditLogActionBadgeVariant(action)
});
